export const MODAL_TN_OPEN = 'MODAL_TN_OPEN';
export const MODAL_TN_CLOSE = 'MODAL_TN_CLOSE';

export const SET_DATE_TN = 'SET_DATE_TN';

export const MODAL_VEHICLE_OPEN = 'MODAL_VEHICLE_OPEN';
export const MODAL_VEHICLE_CLOSE = 'MODAL_VEHICLE_CLOSE';

export const MODAL_VEHICLE_ADD_OPEN = 'MODAL_VEHICLE_ADD_OPEN';
export const MODAL_VEHICLE_ADD_CLOSE = 'MODAL_VEHICLE_ADD_CLOSE';

export const GET_VEHICLES_LIST = 'GET_VEHICLES_LIST';
export const GET_VEHICLES_LIST_SUCCESS = 'GET_VEHICLES_LIST_SUCCESS';
export const GET_VEHICLES_LIST_FAIL = 'GET_VEHICLES_LIST_FAIL';

export const ADD_VEHICLE = 'ADD_VEHICLE';
export const ADD_VEHICLE_SUCCESS = 'ADD_VEHICLE_SUCCESS';
export const ADD_VEHICLE_FAIL = 'ADD_VEHICLE_FAIL';

export const SET_VEHICLE_FORM = 'SET_VEHICLE_FORM';
export const SET_SAVED_DATA = 'SET_SAVED_DATA';

export const MODAL_DRIVERS_OPEN = 'MODAL_DRIVERS_OPEN';
export const MODAL_DRIVERS_CLOSE = 'MODAL_DRIVERS_CLOSE';

export const MODAL_ADD_DRIVER_OPEN = 'MODAL_ADD_DRIVER_OPEN';
export const MODAL_ADD_DRIVER_CLOSE = 'MODAL_ADD_DRIVER_CLOSE';

export const GET_DRIVERS_LIST = 'GET_DRIVERS_LIST';
export const GET_DRIVERS_LIST_SUCCESS = 'GET_DRIVERS_LIST_SUCCESS';
export const GET_DRIVERS_LIST_FAIL = 'GET_DRIVERS_LIST_FAIL';

export const ADD_DRIVER = 'ADD_DRIVER';
export const ADD_DRIVER_SUCCESS = 'ADD_DRIVER_SUCCESS';
export const ADD_DRIVER_FAIL = 'ADD_DRIVER_FAIL';

export const SET_DRIVER_FORM = 'SET_DRIVER_FORM';

export const MODAL_PACKING_TYPE_OPEN = 'MODAL_PACKING_TYPE_OPEN';
export const MODAL_PACKING_TYPE_CLOSE = 'MODAL_PACKING_TYPE_CLOSE';

export const MODAL_ADD_PACKING_TYPE_OPEN = 'MODAL_ADD_PACKING_TYPE_OPEN';
export const MODAL_ADD_PACKING_TYPE_CLOSE = 'MODAL_ADD_PACKING_TYPE_CLOSE';

export const GET_PACKING_TYPE_LIST = 'GET_PACKING_TYPE_LIST';
export const GET_PACKING_TYPE_LIST_SUCCESS = 'GET_PACKING_TYPE_LIST_SUCCESS';
export const GET_PACKING_TYPE_LIST_FAIL = 'GET_PACKING_TYPE_LIST_FAIL';

export const ADD_PACKING_TYPE = 'ADD_PACKING_TYPE';
export const ADD_PACKING_TYPE_SUCCESS = 'ADD_PACKING_TYPE_SUCCESS';
export const ADD_PACKING_TYPE_FAIL = 'ADD_PACKING_TYPE_FAIL';

export const SET_PACKING_TYPE_FORM = 'SET_PACKING_TYPE_FORM';

export const GET_TN_LIST = 'GET_TN_LIST';
export const GET_TN_LIST_SUCCESS = 'GET_TN_LIST_SUCCESS';
export const GET_TN_LIST_FAIL = 'GET_TN_LIST_FAIL';

export const SAVE_TN = 'SAVE_TN';
export const SAVE_TN_SUCCESS = 'SAVE_TN_SUCCESS';
export const SAVE_TN_FAIL = 'SAVE_TN_FAIL';

export const SET_NOTE_TN = 'SET_NOTE_TN';

export const SET_NUMBER_TN = 'SET_NUMBER_TN';

export const MODAL_TN_LIST_OPEN = 'MODAL_TN_LIST_OPEN';
export const MODAL_TN_LIST_CLOSE = 'MODAL_TN_LIST_CLOSE';

export const SET_TN = 'SET_TN';
export const SET_TN_SUCCESS = 'SET_TN_SUCCESS';

export const GET_TN_PIECE_LIST = 'GET_TN_PIECE_LIST';
export const GET_TN_PIECE_LIST_SUCCESS = 'GET_TN_PIECE_LIST_SUCCESS';
export const GET_TN_PIECE_LIST_FAIL = 'GET_TN_PIECE_LIST_FAIL';

export const ADD_PIECE_TO_TN = 'ADD_PIECE_TO_TN';
export const ADD_PIECE_TO_TN_SUCCESS = 'ADD_PIECE_TO_TN_SUCCESS';
export const ADD_PIECE_TO_TN_FAIL = 'ADD_PIECE_TO_TN_FAIL';

export const DELETE_PIECE_FROM_TN = 'DELETE_PIECE_FROM_TN';
export const DELETE_PIECE_FROM_TN_SUCCESS = 'DELETE_PIECE_FROM_TN_SUCCESS';
export const DELETE_PIECE_FROM_TN_FAIL = 'DELETE_PIECE_FROM_TN_FAIL';

export const UPDATE_TN = 'UPDATE_TN';
export const UPDATE_TN_SUCCESS = 'UPDATE_TN_SUCCESS';
export const UPDATE_TN_FAIL = 'UPDATE_TN_FAIL';

export const CONFIRM_TN = 'CONFIRM_TN';
export const CONFIRM_TN_SUCCESS = 'CONFIRM_TN_SUCCESS';
export const CONFIRM_TN_FAIL = 'CONFIRM_TN_FAIL';

export const GET_TN_LIST_UPDATE = 'GET_TN_LIST_UPDATE';

export const DELETE_TN = 'DELETE_TN';
export const DELETE_TN_SUCCESS = 'DELETE_TN_SUCCESS';
export const DELETE_TN_FAIL = 'DELETE_TN_FAIL';

export const GET_TTN_NEXT_NUMBER = 'GET_TTN_NEXT_NUMBER';
export const GET_TTN_NEXT_NUMBER_SUCCESS = 'GET_TTN_NEXT_NUMBER_SUCCESS';
export const GET_TTN_NEXT_NUMBER_FAIL = 'GET_TTN_NEXT_NUMBER_FAIL';
export const DEL_TTN_NEXT_NUMBER = 'DEL_TTN_NEXT_NUMBER';

export const SET_IS_EXPEDITOR = 'SET_IS_EXPEDITOR';

export const SET_SEPARATION_WEIGHT = 'SET_SEPARATION_WEIGHT';

export const GET_TRANSPORT_COMPANY_LIST = 'GET_TRANSPORT_COMPANY_LIST';
export const GET_TRANSPORT_COMPANY_LIST_SUCCESS = 'GET_TRANSPORT_COMPANY_LIST_SUCCESS';
export const GET_TRANSPORT_COMPANY_LIST_FAIL = 'GET_TRANSPORT_COMPANY_LIST_FAIL';

export const ADD_TRANSPORT_COMPANY = 'ADD_TRANSPORT_COMPANY';
export const ADD_TRANSPORT_COMPANY_SUCCESS = 'ADD_TRANSPORT_COMPANY_SUCCESS';
export const ADD_TRANSPORT_COMPANY_FAIL = 'ADD_TRANSPORT_COMPANY_FAIL';

export const SET_TRANSPORT_COMPANY_FORM = 'SET_TRANSPORT_COMPANY_FORM';

export const GET_RESPONSIBLE_PERSON_LIST = 'GET_RESPONSIBLE_PERSON_LIST';
export const GET_RESPONSIBLE_PERSON_LIST_SUCCESS = 'GET_RESPONSIBLE_PERSON_LIST_SUCCESS';
export const GET_RESPONSIBLE_PERSON_LIST_FAIL = 'GET_RESPONSIBLE_PERSON_LIST_FAIL';

export const ADD_RESPONSIBLE_PERSON_TN = 'ADD_RESPONSIBLE_PERSON_TN';
export const ADD_RESPONSIBLE_PERSON_TN_SUCCESS = 'ADD_RESPONSIBLE_PERSON_TN_SUCCESS';
export const ADD_RESPONSIBLE_PERSON_TN_FAIL = 'ADD_RESPONSIBLE_PERSON_TN_FAIL';

export const SET_RESPONSIBLE_PERSON_FORM = 'SET_RESPONSIBLE_PERSON_FORM';

export const SET_SUPPORTING_DOCUMENTS = 'SET_SUPPORTING_DOCUMENTS';

export const MODAL_RESPONSIBLE_PERSON_OPEN = 'MODAL_RESPONSIBLE_PERSON_OPEN';
export const MODAL_RESPONSIBLE_PERSON_CLOSE = 'MODAL_RESPONSIBLE_PERSON_CLOSE';

export const MODAL_RESPONSIBLE_PERSON_ADD_OPEN = 'MODAL_RESPONSIBLE_PERSON_ADD_OPEN';
export const MODAL_RESPONSIBLE_PERSON_ADD_CLOSE = 'MODAL_RESPONSIBLE_PERSON_ADD_CLOSE';

export const MODAL_TRANSPORT_COMPANY_OPEN = 'MODAL_TRANSPORT_COMPANY_OPEN';
export const MODAL_TRANSPORT_COMPANY_CLOSE = 'MODAL_TRANSPORT_COMPANY_CLOSE';
export const MODAL_TRANSPORT_COMPANY_ADD_OPEN = 'MODAL_TRANSPORT_COMPANY_ADD_OPEN';
export const MODAL_TRANSPORT_COMPANY_ADD_CLOSE = 'MODAL_TRANSPORT_COMPANY_ADD_CLOSE';

export const SET_TRAILER_FORM = 'SET_TRAILER_FORM';

export const DELETE_ENTITY = 'DELETE_ENTITY';
export const DELETE_ENTITY_SUCCESS = 'DELETE_ENTITY_SUCCESS';
export const DELETE_ENTITY_FAIL = 'DELETE_ENTITY_FAIL';

export const SET_INITIAL_STATE_TN = 'SET_INITIAL_STATE_TN';
